<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t('checkout') }} {{ $t(type) }} {{ $t('entrepot') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t('public-information') }}
        </v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab-item>
          <v-row class="mx-0 my-2">
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              style="height: 55px"
            >
              {{ ($t('entrepot')) }} : {{ (entrepot ? entrepot.name : '') }}
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              {{ ($t('date')) }} : {{ (date ? date : '') }}
            </v-col>
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              style="height: 55px"
            >
              {{ ($t('status')) }} : {{ (status ? status.name : '') }}
            </v-col>
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              style="height: 55px"
            >
              {{ ($t('branch')) }} : {{ (branch ? branch.name : '') }}
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <tag
                v-model="tag"
                :solo="false"
                :input="tag"
                :height="25"
              />
            </v-col>
            <v-col
              v-if="type == 'receipt' || type == 'remittance'|| type == 'tempReceipt'"
              class="px-3 xs"
              cols="12"
              md="3"
            >
              <autocomplete
                ref="refRelations"
                v-model="relations"
                :value="relations"
                :data="JSON.stringify({refId : null, currency_id : null, type: (type == 'receipt' || type == 'tempReceipt'? ['purchase', 'returnSell'] : ['sell', 'returnPurchase', 'translation'])})"
                :title="$t('relative-document')"
                :disabled="true"
                :type="(type == 'receipt' || type == 'tempReceipt'? 'receiptInvoice' : 'remittanceInvoice')"
              />
            </v-col>
            <v-col
              class="px-3 xs"
              cols="12"
              md="6"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    height="32"
                    width="20"
                    style="min-width: 20px !important;margin-right: 2px !important;"
                    color="primary"
                    class="float-left me-2"
                    v-on="on"
                    v-shortkey="['enter']"
                    @shortkey="checkCount"
                    @click="checkCount"
                  >
                    <v-icon
                      style="font-size: 24px"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('search') }} (enter)</span>
              </v-tooltip>
              <v-text-field
                ref="refSearchBarcode"
                v-model="searchBarcode"
                height="20"
                dense
                outlined
                autofocus
                clearable
                hide-details
                :label="$t('searchBarcode')"
              />
            </v-col>
          </v-row>
          <v-col
            cols="12"
            class="px-2 py-0 "
          >
            <v-data-table
              v-if="headers"
              v-model="selected"
              :height="tableHeight"
              fixed-header
              :headers="showHeaders"
              :items="items"
              :options.sync="tableOptions"
              :server-items-length="totalItems"
              :loading="loading"
              multi-sort
              dense
              :show-select="showSelect"
              hide-default-footer
              item-key="id"
            >
              <template v-slot:item.row="{ item }">
                {{ parseInt(items.indexOf(item))+ parseInt(from) }}
              </template>
              <template v-slot:item.product="{ item }">
                {{ (item.product ? item.product.name : '') }}
              </template>
              <template v-slot:item.product="{ item }">
                {{ (item.product ? item.product.name : '') }}
              </template>
              <template v-slot:item.unit="{ item }">
                {{ (item.unit ? item.unit.fame : '') }}
              </template>
              <template v-slot:item.countCheck="{ item }">
                <div
                  v-if="$store.state.admin"
                     class="d-flex"
                >
                  <v-text-field
                    v-model="item.checked_count"
                    height="20"
                    dense
                    solo
                    flat
                    class="mb-3 ms-1 dense"
                    :suffix="(item.product && item.product.unit ? item.product.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                  />
                </div>
                <div v-if="!$store.state.admin">
                  {{ (item.checked_count ? item.checked_count : 0) }}
                </div>
              </template>
              <template v-slot:item.content="{ item }">
                {{ (item.content ? item.content : '') }}
              </template>
              <template v-slot:item.entrepot="{ item }">
                {{ (item.article_entrepot ? item.article_entrepot.name : '') }}
              </template>
            </v-data-table>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="entrepot"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0">
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-0"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          />
        </v-row>
      </v-card-actions>
      <v-row />
    </v-form>
    <v-dialog
      v-model="wrongArticleDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="wrongArticleDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('diffProductList') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      #
                    </th>
                    <th>
                      {{ $t('name') }}
                    </th>
                    <th>
                      {{ $t('count') }}
                    </th>
                    <th>
                      {{ $t('countCheck') }}
                    </th>
                    <th>
                      {{ $t('diffCount') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in wrongArticles"
                    :key="item.id"
                  >
                    <td>{{ Number(i) + 1 }}</td>
                    <td>{{ item.product.name }}</td>
                    <td>{{ item.count }}</td>
                    <td>{{ $numberFormat(item.checked_count) }}</td>
                    <td>
                      {{ parseFloat(+item.count - +item.checked_count) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                :loading="loading"
                @click="updateStore"
                :disabled="($store.state.admin ? false : true)"
              >
                {{ $t('submitAndRegister') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="pink"
                class="float-end"
                @click="wrongArticleDialog = !wrongArticleDialog"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6" />
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import filePicker from '../../components/general/filePicker/index'
  export default {
    name: 'EntrepotIndex',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      filePicker,
      Task,
    },
    mixins: [General],
    props: ['input', 'formType', 'refId'],
    data: () => ({
      selected: [],
      checkoutEntrepot: 'active',
      wrongArticles: [],
      wrongArticleDialog: false,
      costDialog: false,
      searchBarcode: null,
      attachments: null,
      costManagament: null,
      costItems: null,
      content: null,
      selectedItem: null,
      printDialog: false,
      costListDialog: false,
      deletDialog: false,
      showSelect: false,
      render: false,
      filter: false,
      valid: true,
      detail: null,
      recipientEntrepot: null,
      relations: null,
      productStatus: null,
      productStatusItems: null,
      date: null,
      entrepot: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'receipt',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      selectedHeaders: [],
      search: null,
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
    }),
    computed: {
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'warehouseHandling') {
            if (app.type === 'transferProductStock') {
              if (s.value === 'counting_one' || s.value === 'counting_two' || s.value === 'price' || s.value === 'expire_date') {
              } else {
                return app.selectedHeaders.includes(s)
              }
            } else {
              if (s.value === 'counting_one' || s.value === 'counting_two' || s.value === 'price' || s.value === 'to_product') {
              } else {
                return app.selectedHeaders.includes(s)
              }
            }
          } else {
            if (s.value !== 'to_product') {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        // this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          // app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      relations () {
        var app = this
        if (app.relations && app.relations.article && !app.id) {
          app.items = []
          app.items = app.relations.article
          app.items.map(function (value, key) {
            value.cost = []
          })
        } else {
          // app.addRow()
        }
      },
      entrepot (val, oldVal) {
        if (!oldVal && this.items.length === 0 && !this.id) {
          this.addRow()
        }
      },
    },
    beforeMount () {
      var storage = JSON.parse(localStorage.getItem('token'))
      this.costManagament = storage.init.goodCostManagement.value
      this.type = this.$route.name
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
        this.show()
      } else {
        this.render = true
        if (this.entrepot) {
          this.addRow()
        }
      }
    },
    mounted () {
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 10,
        },
        {
          text: (this.type === 'transferProductStock' ? this.$t('fromProduct') : this.$t('product')),
          sortable: true,
          value: 'product',
          width: 150,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit',
          width: 80,
        },
        {
          text: (this.type === 'warehouseHandling' ? this.$t('counting_final') : this.$t('count')),
          sortable: true,
          value: 'count',
          width: 80,
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'content',
          width: 150,
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'entrepot',
          width: 150,
        },
        {
          text: this.$t('countCheck'),
          sortable: false,
          value: 'countCheck',
          width: 150,
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
    },
    methods: {
      changeEntrepotAtRow (item, index) {
      },
      convertUnit (item) {
        item.count = item.countUnit * item.unit.value
      },
      unitItems (item) {
        if (item.product) {
          var units = [item.product.unit]
          if (item.product.units) {
            item.product.units.map(function (value, index) {
              value.unit.value = value.value
              units.push(value.unit)
            })
          }
          if (!item.unit) {
            item.unit = item.product.unit
          }
          // if (!item.unit && this.id) {
          //   if (item.unit2) {
          //     item.unit = item.unit2
          //     item.unit.value = item.unitRate
          //   } else {
          //     item.unit = item.product.unit
          //   }
          // }
          return units
        } else {
          return []
        }
      },
      openCostListDialog (item) {
        this.costItems = item
        this.costListDialog = true
      },
      openCostDialog (item) {
        this.selectedItem = item
        this.costDialog = true
      },
      setCost (val) {
        var index = this.items.indexOf(this.selectedItem)
        this.items[index].cost.push(val)
        this.costDialog = false
        this.selectedItem = null
      },
      addRow () {
        if (this.items.length >= 100) {
          this.snakbarText = this.$t('youCantmoreThan100Record')
          this.snakbarColor = 'blue'
          this.snakbar = true
          return false
        }
        this.items.push({
          product: null,
          cost: [],
          stock: null,
          inEdit: 0,
          outEdit: 0,
          countUnit: null,
          counting_one: null,
          counting_two: null,
          expire_date: null,
          to_product: null,
          count: null,
          price: null,
          unit: null,
          content: null,
          article_entrepot: null,
        })
      },
      remove (item, index1) {
        var index = this.items.indexOf(this.deleteItem)
        var cost = this.deleteItem.cost
        this.items.splice(index, 1)
        this.deletDialog = false
        if (cost.length > 0) {
          this.removeCost(cost)
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      checkProduct (item, key) {
        if (item.product) {
          var index = this.items.findIndex(x => x.product.id === item.product.id)
          if (!this.id) {
            item.price = item.product.costs
          }
          if (index !== key) {
            // this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        } else {
          this.removeCost(this.items[key].cost)
          this.items[key].cost = []
        }
      },
      checkCount () {
        var app = this
        app.wrongArticles = []
        this.items.map(function (value, index) {
          var count = 0
          if (app.type === 'remittance') {
            count = value.count
          }
          if (app.type === 'receipt' || app.type === 'tempReceipt') {
            count = value.count
          }
          if (parseFloat(app.searchBarcode) === parseFloat(value.product.barcode)) {
            value.checked_count = parseFloat((value.checked_count ? value.checked_count : 0)) + 1
            if (value.checked_count > count) {
              app.twiceBeep()
              app.snakbarText = app.$t('addedCountMoreThanCount') + ' | ' + value.product.name
              app.snakbarColor = 'pink'
              app.snakbar = true
            } else {
              app.beep()
            }
          } else {
            app.snakbarText = app.$t('productNotFound')
            app.snakbarColor = 'pink'
            app.snakbar = true
            app.twiceBeep()
          }
          if (value.checked_count !== count) {
            app.wrongArticles.push(value)
          }
        })
        app.searchBarcode = null
        app.$refs.refSearchBarcode.focus()
      },
      beep () {
        var snd = new Audio('data:audio/wav;base64,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')
        snd.play()
      },
      twiceBeep () {
        var snd = new Audio('data:audio/mpeg;base64,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')
        snd.play()
        snd.play()
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          app.remove(value, key)
        })
      },
      update () {
        var app = this
        app.wrongArticles = []
        this.items.map(function (value, index) {
          var count = 0
          if (app.type === 'remittance') {
            count = value.count
          }
          if (app.type === 'receipt' || app.type === 'tempReceipt') {
            count = value.count
          }
          if (parseFloat(value.checked_count) !== parseFloat(count)) {
            app.wrongArticles.push(value)
          }
        })
        if (this.wrongArticles && this.wrongArticles.length > 0) {
          this.wrongArticleDialog = true
        } else {
          if (this.wrongArticles.length === 0) {
            this.updateStore()
          }
        }
      },
      updateStore () {
        var app = this
        app.wrongArticleDialog = false
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'entrepot/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'entrepot/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.type = res.type
              app.id = res.id
              app.attachments = res.attachments
              app.entrepot = res.entrepot
              app.recipientEntrepot = res.recipient_entrepot
              app.detail = res.detail
              app.branch = res.branch
              app.relations = res.invoice
              app.items = res.articles
              app.date = res.date
              app.content = res.content
              app.status = (res.last_status ? res.last_status.status : null)
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.selected = []
        this.printDialog = false
        this.attachments = null
        this.deletDialog = false
        this.showSelect = false
        this.filter = false
        this.valid = true
        this.costItems = null
        this.detail = null
        this.recipientEntrepot = null
        this.relations = null
        this.productStatus = null
        this.productStatusItems = null
        this.entrepot = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.items = []
        this.sortBy = []
        this.dialog = null
        this.timer = 0
        this.totalItems = 1000
        this.isLoading = false
        this.snakbar = false
        this.taskId = null
        this.snakbarText = null
      },
      remoceCostList (cost) {
        var index = this.costItems.cost.indexOf(cost)
        this.costItems.cost.splice(index, 1)
        this.costListDialog = false
        this.removeCost([cost])
      },
      removeCost (cost) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'CostIncome', {
          params: {
            deleteItems: cost,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
